import React from 'react';

import Thumb_1 from '../../../Images/modals/films/portfolio/thumb-1.png';
import Img_1 from '../../../Images/modals/films/portfolio/img-1.png';
import Thumb_2 from '../../../Images/modals/films/portfolio/thumb-2.png';
import Img_2 from '../../../Images/modals/films/portfolio/img-2.png';
import Thumb_3 from '../../../Images/modals/films/portfolio/thumb-3.png';
import Img_3 from '../../../Images/modals/films/portfolio/img-3.png';
import Thumb_4 from '../../../Images/modals/films/portfolio/thumb-4.png';
import Img_4 from '../../../Images/modals/films/portfolio/img-4.png';
import Thumb_5 from '../../../Images/modals/films/portfolio/thumb-5.png';
import Img_5 from '../../../Images/modals/films/portfolio/img-5.png';
import Thumb_6 from '../../../Images/modals/films/portfolio/thumb-6.png';
import Img_6 from '../../../Images/modals/films/portfolio/img-6.png';
import Thumb_7 from '../../../Images/modals/films/portfolio/thumb-7.png';
import Img_7 from '../../../Images/modals/films/portfolio/img-7.png';
import Thumb_8 from '../../../Images/modals/films/portfolio/thumb-8.png';
import Img_8 from '../../../Images/modals/films/portfolio/img-8.png';
import Thumb_9 from '../../../Images/modals/films/portfolio/thumb-9.png';
import Img_9 from '../../../Images/modals/films/portfolio/img-9.png';

import MobImg_1 from '../../../Images/modals/films/portfolio/mobile/img_1-mob.png';
import MobImg_2 from '../../../Images/modals/films/portfolio/mobile/img_2-mob.png';
import MobImg_3 from '../../../Images/modals/films/portfolio/mobile/img_3-mob.png';
import MobImg_4 from '../../../Images/modals/films/portfolio/mobile/img_4-mob.png';
import MobImg_5 from '../../../Images/modals/films/portfolio/mobile/img_5-mob.png';
import MobImg_6 from '../../../Images/modals/films/portfolio/mobile/img_6-mob.png';
import MobImg_7 from '../../../Images/modals/films/portfolio/mobile/img_7-mob.png';
import MobImg_8 from '../../../Images/modals/films/portfolio/mobile/img_8-mob.png';
import MobImg_9 from '../../../Images/modals/films/portfolio/mobile/img_9-mob.png';

import NetflixLogo from '../../../Images/icons/netflix-logo.png';
import GaumontLogo from '../../../Images/icons/gaumont-logo.png';
import ParamountLogo from '../../../Images/icons/paramount-logo.png';
import AppleLogo from '../../../Images/icons/apple-tv-logo.png';
import DisneyLogo from '../../../Images/icons/disney-logo.png';
import UnivisionLogo from '../../../Images/icons/univision-logo.png';
import VixLogo from '../../../Images/icons/vix-logo.png';
import AmazonLogo from '../../../Images/icons/amazon-logo.png';
import StudiosLogo from '../../../Images/icons/amazon-studio-logo.png';
import PrimeVideoLogo from '../../../Images/icons/prime-video-logo.png';
import KuterLogo from '../../../Images/icons/kuter-logo.png';

export const TITLE_PORT = [
  {
    textSize: '3.375rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>PORTAFOLIO</span>,
  },
];

export const PORT_FILMS = [
  {
    textSize: '0.75rem',
    marginBottom: '0px',
    textMobile: '0.75rem',
    renderContent: () => (
      <span>
        *Todo el trabajo presentado en este portafolio forma parte de la
        trayectoria profesional de Jonathan Bouzali como Productor. Cada pieza
        corresponde a proyectos en los que ha participado directamente en su rol
        de Productor.
      </span>
    ),
  },
];

export const slides = [
  {
    id: 'film-1',
    category: 'PELÍCULA',
    title: 'México 86',
    description:
      'La historia real de cómo México, casi de rebote y contra todo pronóstico, terminó organizando el Mundial de 1986. La cinta muestra la mezcla de audacia, improvisación, corrupción y creatividad que hizo posible el torneo en medio de crisis, terremotos y presiones internacionales.',
    trailer: 'https://youtu.be/XdMYZV3imGc?si=qPX3iOKvxFnyOAOv',
    background: Img_1,
    mobBg: MobImg_1,
    thumbnail: Thumb_1,
    bgColor: 'rgba(105, 124, 13, 1)',
    logos: [
      { src: NetflixLogo, className: 'logo-netflix' },
      { src: GaumontLogo, className: 'logo-gaumon' },
    ],
  },
  {
    id: 'film-2',
    category: 'SERIE',
    title: 'Futuro Desierto',
    description:
      'Tras una selección rigurosa, FUZHIPIN elige a diez familias y pequeñas empresas para entregarles androides sin costo y observar, en la vida real, cómo nacen los vínculos afectivos con la IA. Gustav, viudo y empleado de la compañía, vive con María, un androide creado con la información de su esposa fallecida. En México, la adolescencia y el choque cultural tensan la convivencia hasta que Gustav descubre la verdad: su familia también forma parte de la prueba.',
    trailer: 'https://www.youtube.com/watch?v=XD7zX5gk8wg',
    background: Img_2,
    mobBg: MobImg_2,
    thumbnail: Thumb_2,
    bgColor: 'rgba(144, 182, 165, 1)',
    logos: [
      { src: NetflixLogo, className: 'logo-netflix' },
      { src: ParamountLogo, className: 'logo-paramount' },
      { src: GaumontLogo, className: 'logo-gaumon' },
    ],
  },
  {
    id: 'film-3',
    category: 'SERIE',
    title: 'FAMILIA DE  MEDIANOCHE',
    description:
      'Marigaby Tamayo es una ambiciosa estudiante de medicina que pasa sus noches salvando vidas en una Ciudad de México desbordante, contrastante y fascinante, a bordo de la ambulancia privada de su familia.',
    trailer:
      'https://tv.apple.com/mx/clip/choice/umc.cmc.7ah58ve1511bxiiup3o7s8hg8?targetId=umc.cmc.1xkd0bjglgv5x1jxiteog2833&targetType=Show',
    background: Img_3,
    mobBg: MobImg_3,
    thumbnail: Thumb_3,
    bgColor: 'rgba(156, 63, 65, 1)',
    logos: [{ src: AppleLogo, className: 'logo-apple' }],
  },
  {
    id: 'film-4',
    category: 'SERIE',
    title: 'EL REPATRIADO',
    description:
      'Leonel tiene dudas sobre su pasado, pero no puede concebir ser expulsado a México en el punto más alto de su carrera, sin poder demostrar que es ciudadano estadounidense.',
    trailer: 'https://www.youtube.com/watch?v=H7sju5OTnKo',
    background: Img_4,
    mobBg: MobImg_4,
    thumbnail: Thumb_4,
    bgColor: 'rgba(46, 100, 83, 1)',
    logos: [{ src: DisneyLogo, className: 'logo-disney' }],
  },
  {
    id: 'film-5',
    category: 'SERIE',
    title: 'TIJUANA',
    description:
      'Periodistas locales descubren una conspiración tras el asesinato en las calles de un candidato presidencial mexicano.',
    trailer: 'https://www.youtube.com/watch?v=Y3ghrsJ2Pok',
    background: Img_5,
    mobBg: MobImg_5,
    thumbnail: Thumb_5,
    bgColor: 'rgba(164, 152, 138, 1)',
    logos: [
      { src: NetflixLogo, className: 'logo-netflix' },
      { src: UnivisionLogo, className: 'logo-univision' },
    ],
  },
  {
    id: 'film-6',
    category: 'PELÍCULA',
    title: '37KM',
    description:
      'La historia de Alonso, un profesor universitario y escritor que vive de las apariencias. Su hija de 10 años tiene autismo y su esposa Ximena descubre que su seguro de salud ha sido cancelado por falta de pago. Para conseguir el dinero, Alonso decide correr el maratón de la CDMX y entrenar con la legendaria tribu tarahumara.',
    trailer: 'https://www.primevideo.com/-/es/detail/37-Kms/',
    background: Img_6,
    mobBg: MobImg_6,
    thumbnail: Thumb_6,
    bgColor: 'rgba(182, 156, 87, 1)',
    logos: [{ src: VixLogo, className: 'logo-vix' }],
  },
  {
    id: 'film-7',
    category: 'PELÍCULA',
    title: 'souvenir',
    description:
      'Para recuperar a su hijo retenido en Estados Unidos, Isabel alquila su vientre para gestar al bebé de una pareja que no puede concebir, pero un incidente inesperado la obliga a tomar decisiones extremas para cumplir con su parte del trato.',
    trailer: 'https://vimeo.com/388565050?fl=pl&fe=sh',
    background: Img_7,
    mobBg: MobImg_7,
    thumbnail: Thumb_7,
    bgColor: 'rgba(39, 49, 18, 1)',
    logos: [{ src: AmazonLogo, className: 'logo-amzon' }],
  },
  {
    id: 'film-8',
    category: 'REALITY',
    title: 'the Bachelor Japan',
    description:
      'Este reality romántico lleva al soltero y a los espectadores a un viaje lleno de drama y pasión, mientras varias mujeres compiten por conquistar su corazón a través de diversas citas grupales y encuentros íntimos.',
    trailer: 'https://vimeo.com/785716402/fd86a88193?fl=pl&fe=sh',
    background: Img_8,
    mobBg: MobImg_8,
    thumbnail: Thumb_8,
    bgColor: 'rgba(187, 166, 101, 1)',
    logos: [
      { src: StudiosLogo, className: 'logo-studios' },
      { src: PrimeVideoLogo, className: 'logo-prime' },
    ],
  },
  {
    id: 'film-9',
    category: 'CORTOMETRAJE',
    title: 'MICTLÁN',
    description:
      'Mictlán cuenta la historia de unos chicos que prueban un juego de realidad inmersiva inspirado en la mitología azteca. Lo que empieza como diversión se convierte en una experiencia mortal cuando descubren que los desafíos del inframundo mexica tienen consecuencias reales.',
    trailer: 'https://vimeo.com/949992885?fl=pl&fe=sh',
    background: Img_9,
    mobBg: MobImg_9,
    thumbnail: Thumb_9,
    bgColor: 'rgba(112, 52, 42, 1)',
    logos: [{ src: KuterLogo, className: 'logo-kuter' }],
  },
];
